export class QuestionnaireResponseModel {
  constructor(
        private presence : boolean,
        private responseByQuestion : Map<string,any>) {
  }

  public isComing() : boolean {
    return this.presence;
  }

  public getResponse(question: string) : string {
    return this.responseByQuestion.get(question);
  }

  public getAllResponses() : Map<string,any> {
    return this.responseByQuestion;
  }
}


// WEBPACK FOOTER //
// ./src/app/models/questionnaireresponse-model.ts